import { useState } from "react"

export const useZoom = (
  zoomLevels: number[] = [1, 0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3, 0.2, 0.1]
) => {
  const [zoomIndex, setZoomIndex] = useState(0)
  const zoom = zoomLevels[zoomIndex]

  const toggleZoom = () => {
    setZoomIndex((prev) => (prev + 1) % zoomLevels.length)
  }

  const setZoom = (index: number) => {
    if (index >= 0 && index < zoomLevels.length) {
      setZoomIndex(index)
    }
  }

  const handleZoomIn = () => {
    if (zoomIndex !== 0) {
      setZoomIndex((currentZoomIndex) => currentZoomIndex - 1)
    }
  }

  const handleZoomOut = () => {
    if (zoomIndex !== zoomLevels.length - 1) {
       setZoomIndex((currentZoomIndex) => currentZoomIndex + 1)
    }
  }

  return {
    zoom,
    zoomIndex,
    toggleZoom,
    setZoom,
    handleZoomOut,
    handleZoomIn,
    zoomLevels,
  }
}
